import { axios2 } from '@/lib/axios';
import { useQuery } from 'react-query';


export const getEarnings = (flag: string, page: number, search: string = '') => {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  return axios2.get(`/admin-api/get-subscriptions?subscription_type=${flag}${searchParam}&page=${page}&page_size=10`);
};

export const useGetEarnings = (flag: string, page: number, search: string = '') => {
  return useQuery({
    queryKey: ['get-earnings', flag, page, search],
    queryFn: () => getEarnings(flag, page, search),
  });
};
